<mat-card appearance="outlined" class="mainDiv">
  <mat-card-header>
    <mat-card-title>
      {{'subscription.header' | translate}} <br>
    </mat-card-title>
  </mat-card-header>
  @if (!(loadingMemberId$ | async)) {
    <mat-card-content class="h-100">
      <div class="infoDiv">
        <div class="userDiv">
          {{ user?.name + ' #' + user?.permitNumber }}
        </div>
        <div>
          {{'subscription.form.society.title' | translate }}
          @for (s of (model$ | async)?.societies; track s; let i = $index) {
            <span>
              {{ i !=0 ? ", ": ""}} {{s.legalName }} ({{ s.neq}})
            </span>
          }
        </div>
      </div>
      @if (!(loadingPeriods$ | async)) {
        <div>
          @if (!selectedPeriod || userCanEditForm == false) {
            <div class="noPeriodDiv">
              {{'subscription.form.noPeriod' | translate }}
            </div>
          }
          @if (selectedPeriod && userCanEditForm && !subscriptionIsBlocked) {
            <mat-tab-group #tabs
              class="formTabs"
              [selectedIndex]="selectedIndex"
              dynamicHeight
              (selectedTabChange)="tabChanged($event)">
              <!-- PREIMUM BASE  -->
              <mat-tab [disabled]="selectedIndex != 0" [label]="'subscription.form.premium.title' | translate" >
                <div class="tab">
                  @if (!(loadingPremiumData$ | async)) {
                    <div class="bold">
                      {{ 'subscription.form.premium.title' | translate }}
                    </div>
                    <odq-section-separator></odq-section-separator>
                    <br />
                    <odq-premium [model]="model$ | async"
                      [selectedPremium]="selectedPremium"
                      [inactiveMemberForSubscription]="(inactiveMemberForSubscription$ | async)"
                    ></odq-premium>
                    <br />
                    @if (userCanAddSurplus) {
                      <odq-surplus [model]="model$ | async"
                        [selectedPremium]="selectedPremium"
                        (onUserDecidedSurplus)= "userDecidedSurplus($event)"
                        [inactiveMemberForSubscription]="(inactiveMemberForSubscription$ | async)"
                      ></odq-surplus>
                    }
                    <br />
                    <odq-section-separator></odq-section-separator>
                    <div class="d-flex flex-row align-items-center m-2">
                      <div class="d-flex flex-grow-1">
                      </div>
                      <div  fxlayout="row" fxlayoutgap="10px">
                        <button mat-raised-button [disabled]="!userHasDecidedSurplus || selectedPremium.total==0" (click)="validateSurplus()">
                          <mat-icon>navigate_next</mat-icon>{{'form.nextStep' | translate}}
                        </button>
                      </div>
                    </div>
                    <br />
                  } @else {
                    <div class="loading-spinner">
                      <mat-spinner diameter="100"></mat-spinner>
                    </div>
                  }
                  @if ((savingReportReclamationValidation$ | async)) {
                    <div class="spinner-saving">
                      <mat-spinner diameter="100"></mat-spinner>
                    </div>
                  }
                </div>
              </mat-tab>
              <!-- REGISTRATION PAYMENT -->
              <mat-tab [disabled]="selectedIndex != 1" [label]="'subscription.form.registrationPayment.title' | translate ">
                <div class="tabPayment">
                  <div class="bold">
                    {{ 'subscription.form.registrationPayment.title' | translate }}
                  </div>
                  <odq-section-separator></odq-section-separator>
                  <br />
                  @if (selectedPremium?.total>0) {
                    <odq-registration-payment [model]="model$ | async"
                      [selectedPremium]="selectedPremium"
                    [inactiveMemberForSubscription]="(inactiveMemberForSubscription$ | async)"></odq-registration-payment>
                  }
                  @if (selectedPremium?.total<=0) {
                    <odq-registration-credit [model]="model$ | async"
                    [selectedPremium]="selectedPremium"></odq-registration-credit>
                  }
                  <br />
                  <odq-section-separator></odq-section-separator>
                  <div class="d-flex flex-row align-items-center m-2">
                    <div class="d-flex flex-grow-1">
                    </div>
                    <div  fxlayout="row" fxlayoutgap="10px">
                      <button mat-raised-button (click)="previousStep()">
                        <mat-icon>navigate_before</mat-icon>{{'form.previousStep' | translate}}
                      </button>
                    </div>
                  </div>
                  <br />
                </div>
              </mat-tab>
              <!-- CONFIRMATION PAYMENT -->
              <mat-tab [disabled]="selectedIndex != 2" [label]="'subscription.form.confirmationPayment.title' | translate">
                <div class="tab">
                  <odq-navigation-step-wrapper [title]="'subscription.form.confirmationPayment.title' "
                    [showPreviousStep]="false"
                    [showNextStep]="false"
                    (onPreviousStep)="previousStep()"
                    (onNextStep)="nextStep()">
                    <odq-confirmation-payment [selectedPremium]="selectedPremium"
                      [model]="model$ | async"
                    [paymentReceipt]="paymentReceipt$ | async"></odq-confirmation-payment>
                  </odq-navigation-step-wrapper>
                </div>
              </mat-tab>
            </mat-tab-group>
          }
        </div>
      } @else {
        <div class="loading-spinner">
          <mat-spinner diameter="100"></mat-spinner>
        </div>
      }
    </mat-card-content>
  } @else {
    <div class="loading-spinner">
      <mat-spinner diameter="100"></mat-spinner>
    </div>
  }
</mat-card>
